var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.219,
    height: 44.209,
    viewBox: "0 0 44.219 44.209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 44.219,
    height: 44.209,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M12.451,31.073a.651.651,0,0,1-.46-.19L.861,19.755a.655.655,0,0,1,0-.923L18.84.855a.652.652,0,0,1,.922,0L30.889,11.983a.652.652,0,0,1,0,.922L12.912,30.883a.656.656,0,0,1-.461.19M2.244,19.293,12.451,29.5,29.507,12.443,19.3,2.238Z",
    transform: "translate(0.204 0.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M1.527,20.147a.655.655,0,0,1-.461-.19C-.21,18.68-.345,16.483.683,13.765A23.157,23.157,0,0,1,6,5.992c5.3-5.3,11.433-7.469,13.964-4.935a.652.652,0,1,1-.922.922C17.308.245,12.025,1.813,6.923,6.914A21.826,21.826,0,0,0,1.9,14.226c-.825,2.178-.794,3.93.085,4.807a.652.652,0,0,1-.461,1.113",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M3.031,21.652a.652.652,0,0,1-.461-1.113L20.547,2.561a.652.652,0,0,1,.922.922L3.492,21.462a.655.655,0,0,1-.461.19",
    transform: "translate(0.722 0.719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M4.616,23.238a.652.652,0,0,1-.461-1.113L22.132,4.147a.652.652,0,1,1,.922.922L5.077,23.048a.655.655,0,0,1-.461.19",
    transform: "translate(1.203 1.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M14.53,24.234a.649.649,0,0,1-.46-.19L8.7,18.674a.654.654,0,0,1,0-.923l9.062-9.061a.67.67,0,0,1,.922,0l5.369,5.369a.65.65,0,0,1,0,.922l-9.061,9.062a.655.655,0,0,1-.461.19m-4.448-6.021L14.53,22.66l8.14-8.139-4.449-4.449Z",
    transform: "translate(2.582 2.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M15.355,18.834a3.485,3.485,0,1,1,2.466-1.019,3.481,3.481,0,0,1-2.466,1.019m0-5.668A2.181,2.181,0,1,0,16.9,13.8a2.172,2.172,0,0,0-1.545-.639",
    transform: "translate(3.603 3.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M27.538,32.79a5.258,5.258,0,1,1,3.72-1.538,5.251,5.251,0,0,1-3.72,1.538m0-9.213a3.955,3.955,0,0,0-2.8,6.753,4.052,4.052,0,0,0,5.595,0,3.955,3.955,0,0,0-2.8-6.753",
    transform: "translate(6.762 6.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M30.084,39.789a.647.647,0,0,1-.46-.192l-8.173-8.173a.65.65,0,0,1-.158-.665l1.128-3.416-7.665-7.665a.652.652,0,0,1,0-.922l4.01-4.01a.67.67,0,0,1,.922,0l7.665,7.665,3.416-1.128a.648.648,0,0,1,.665.158l8.173,8.173a.65.65,0,0,1,0,.922L30.546,39.6a.652.652,0,0,1-.461.192m-7.427-9,7.427,7.429,8.14-8.14L30.8,22.647l-3.416,1.129a.649.649,0,0,1-.665-.158l-7.487-7.489-3.088,3.089,7.487,7.487a.647.647,0,0,1,.158.665Z",
    transform: "translate(4.421 4.42)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.ba12d771d33ecf370d7ac6472044f826.svg";
export { ForwardRef as ReactComponent };